import React from 'react';
import { Box, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { es as esLocale } from 'date-fns/locale';
import { TOKENS } from '../state/colors';
import { fs } from '../state/typography';

// SPEC-100 (RN-001) — ventana por defecto: hoy-14 (inclusive) a hoy (inclusive), 15 días.
export function calcularRangoPorDefecto(hoy: Date = new Date()): { desde: Date; hasta: Date } {
  const hasta = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
  const desde = new Date(hasta);
  desde.setDate(desde.getDate() - 14);
  return { desde, hasta };
}

interface DateRangeControlProps {
  desde: Date;
  hasta: Date;
  onChange: (rango: { desde: Date; hasta: Date }) => void;
}

export function DateRangeControl({ desde, hasta, onChange }: DateRangeControlProps) {
  // SPEC-100 (RN-003) — desde > hasta no debe disparar peticiones; se muestra error
  // y se conserva el último rango válido (el padre solo recibe onChange si es válido).
  const error = desde > hasta;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px' }} data-testid="date-range-control">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <DatePicker
            label="Desde"
            value={desde}
            onChange={(nuevaFecha) => {
              if (nuevaFecha) onChange({ desde: nuevaFecha, hasta });
            }}
            slotProps={{
              textField: {
                size: 'small',
                error,
                inputProps: { 'data-testid': 'date-range-desde' },
                sx: { width: '160px', backgroundColor: '#fff' },
              },
            }}
          />
          <Typography sx={{ color: TOKENS.muted, fontFamily: 'Poppins, sans-serif', fontSize: fs(13) }}>
            —
          </Typography>
          <DatePicker
            label="Hasta"
            value={hasta}
            onChange={(nuevaFecha) => {
              if (nuevaFecha) onChange({ desde, hasta: nuevaFecha });
            }}
            slotProps={{
              textField: {
                size: 'small',
                error,
                inputProps: { 'data-testid': 'date-range-hasta' },
                sx: { width: '160px', backgroundColor: '#fff' },
              },
            }}
          />
        </Box>
        {error && (
          <Typography
            data-testid="date-range-error"
            sx={{ color: TOKENS.red, fontFamily: 'Poppins, sans-serif', fontSize: fs(12) }}
          >
            "Desde" no puede ser posterior a "Hasta"
          </Typography>
        )}
      </Box>
    </LocalizationProvider>
  );
}
